export default function(cookie) {
    const apiLoc = "/api/locations/all";
    let prefLocCookie = cookie;
    if (prefLocCookie !== undefined && prefLocCookie !== "") {
      fetch(apiLoc)
        .then(response => response.json())
        .then(data => {
          let headerUtilItem = document.querySelector('.header__util-item--dealer');
          if (!headerUtilItem) return;
          let locationData = data;
          let locationInfo = locationData.find(i => i.id === prefLocCookie);
          let headerUtilMenu = headerUtilItem.querySelector('.header__util-menu');
          let headerUtilIcon = headerUtilItem.querySelector('button.header__util-label i')
          if(locationInfo !== undefined && locationInfo !== null){
            let headerUtilItemBtn = headerUtilItem.querySelector('button');
            headerUtilItem.querySelector('a.header__util-label').style.display = "none";
            headerUtilItem.querySelector('button.header__util-label').style.display = "flex";
            headerUtilMenu.querySelector('.header__util-menu-custom-item__address-link').href = `https://www.google.com/maps/dir/?api=1&destination=${locationInfo.latitude},${locationInfo.longitude}`;
            headerUtilMenu.querySelector('.header__util-menu-custom-item__address1').innerText = locationInfo.address1;
            headerUtilMenu.querySelector('.header__util-menu-custom-item__address2').innerText = locationInfo.address2;
            headerUtilMenu.querySelector('.header__util-menu-custom-item__city').innerText = locationInfo.city;
            headerUtilMenu.querySelector('.header__util-menu-custom-item__state').innerText = locationInfo.state;
            headerUtilMenu.querySelector('.header__util-menu-custom-item__zip').innerText = locationInfo.zip;
            headerUtilMenu.querySelector('.header__util-menu__dealer .header__util-menu-custom-item > h5').innerText = locationInfo.name;
            headerUtilItemBtn.innerHTML = `${headerUtilIcon.outerHTML} ${locationInfo.name}`;

            if(locationInfo.phone && headerUtilMenu.querySelector('.header__util-menu-custom-item__phone')){
              headerUtilMenu.querySelector('.header__util-menu-custom-item__phone').innerText = locationInfo.phone;
            }
            
          }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
    else{
      let headerUtilItem = document.querySelector('.header__util-item--dealer');
      if (!headerUtilItem) return;
      headerUtilItem.querySelector('a.header__util-label').style.display = "flex";
      headerUtilItem.querySelector('button.header__util-label').style.display = "none";
    }
}

